// extracted by mini-css-extract-plugin
export default {"container":"styles_container__dUL4R","topContainer":"styles_topContainer__YX1NQ","bottomContainer":"styles_bottomContainer__Y5Fhu"};